import React from 'react';
import { motion } from 'framer-motion';
import { Container, Typography, Box, Grid, Paper, Button } from '@mui/material';
import Layout from './Layout';
import { colors } from '../colors';

const Partners = () => {
    return (
        <Layout>
            {/* Blue Banner */}
            <Box
                sx={{
                    backgroundColor: colors.primaryBannerBlue,
                    color: 'white',
                    padding: { xs: '5px 0', sm: '10px 0' }, // Responsive padding
                    textAlign: 'center',
                    fontSize: { xs: '1rem', sm: '1.2rem' },
                    fontWeight: '500',
                }}
            >
                PARTNERS
            </Box>
            <Container maxWidth="lg" sx={{ mt: 5 }}>

                {/* Hero Section */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.5 }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #F8C7C3, #F4D8C2)',  // Dark blue header background
                            color: 'white',
                            padding: '50px 20px',
                            textAlign: 'center',
                            borderRadius: '10px',
                            boxShadow: '0 6px 15px rgba(0, 0, 0, 0.1)',  // Soft shadow effect
                        }}
                    >
                        <Typography variant="h3"
                            gutterBottom
                            sx={{
                                fontWeight: 'bold',  // Bold text for the title
                                letterSpacing: '1px',  // Slightly spaced letters for a more elegant feel
                                color: colors.racineRedDark,  // Coral red for the title to stay within your theme
                            }}
                        >
                            Our Global Partners
                        </Typography>
                        <Typography variant="h6"
                            sx={{
                                color: colors.primaryApplicationText,  // Coral red for the title to stay within your theme
                            }}
                        >
                            We collaborate with industry leaders worldwide to deliver top-tier research and insights.
                        </Typography>
                    </Box>
                </motion.div>

                {/* Partners List Section */}
                <motion.div
                    initial={{ x: '-100vw' }}
                    animate={{ x: 0 }}
                    transition={{ type: 'spring', stiffness: 120 }}
                >
                    <Box textAlign="center" mt={8}>
                        <Typography variant="h4" gutterBottom>
                            Meet Our Partners
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <Paper
                                    elevation={3}
                                    sx={{
                                        padding: '20px',
                                        backgroundColor: '#FAFAFA',
                                        borderLeft: `5px solid ${colors.racineRedDark}`,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        '&:hover': { transform: 'scale(1.05)', transition: 'transform 0.3s ease' },
                                    }}
                                >
                                    <Typography variant="h6" sx={{ color: colors.racineRedDark }}>Partner 1</Typography>
                                    <Typography sx={{ color: '#333333' }}>
                                        Leading research and insights provider in North America.
                                    </Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper
                                    elevation={3}
                                    sx={{
                                        padding: '20px',
                                        backgroundColor: '#FAFAFA',
                                        borderLeft: `5px solid ${colors.racineRedDark}`,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        '&:hover': { transform: 'scale(1.05)', transition: 'transform 0.3s ease' },
                                    }}
                                >
                                    <Typography variant="h6" sx={{ color: colors.racineRedDark }}>Partner 2</Typography>
                                    <Typography sx={{ color: '#333333' }}>
                                        Strategic partner for global surveys across Europe and Asia.
                                    </Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper
                                    elevation={3}
                                    sx={{
                                        padding: '20px',
                                        backgroundColor: '#FAFAFA',
                                        borderLeft: `5px solid ${colors.racineRedDark}`,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        '&:hover': { transform: 'scale(1.05)', transition: 'transform 0.3s ease' },
                                    }}
                                >
                                    <Typography variant="h6" sx={{ color: colors.racineRedDark }}>Partner 3</Typography>
                                    <Typography sx={{ color: '#333333' }}>
                                        Industry leader in data analytics and actionable insights.
                                    </Typography>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Box>
                </motion.div>

                {/* Call to Action for New Partners */}
                <motion.div
                    initial={{ x: '100vw' }}
                    animate={{ x: 0 }}
                    transition={{ type: 'spring', stiffness: 120 }}
                >
                    <Box textAlign="center" mt={8}>
                        <Typography variant="h4" gutterBottom>
                            Interested in Partnering With Us?
                        </Typography>
                        <Typography variant="h6" paragraph>
                            Join our global network and collaborate with us to bring cutting-edge research solutions.
                        </Typography>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: colors.racineRedDark,
                                color: 'white',
                                '&:hover': { backgroundColor: '#D0453E' },
                                padding: '10px 20px',
                                marginTop: '20px',
                            }}
                        >
                            Contact Us
                        </Button>
                    </Box>
                </motion.div>
            </Container>
        </Layout>
    );
};

export default Partners;
